var map = {
	"./en.json": "UGjV",
	"./fr.json": "F0e/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G6Zw";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/orders [A-Za-z0-9-_,\s]+\.json$/
// module id = G6Zw
// module chunks = 1